import React from 'react';
import { Ghost, Sparkles, MessageSquare } from 'lucide-react';

export default function EmptyAnalyticsState({ title = "It's awfully quiet in here...", message = "Your AI is waiting for its first conversation. Once users start chatting, the magic will appear here!" }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] w-full p-8 animate-fadeIn">
      <div className="relative mb-6">
        <div className="absolute inset-0 bg-blue-100 rounded-full blur-3xl opacity-50 animate-pulse"></div>
        <div className="relative bg-gradient-to-br from-white to-blue-50 w-32 h-32 rounded-full border border-blue-100 shadow-xl flex items-center justify-center">
          <Ghost className="w-12 h-12 text-blue-300 animate-bounce" style={{ animationDuration: '3s' }} />
          <Sparkles className="w-6 h-6 text-yellow-400 absolute top-4 right-4 animate-pulse" />
          <MessageSquare className="w-5 h-5 text-purple-300 absolute bottom-6 left-4 transform -rotate-12" />
        </div>
      </div>
      
      <h3 className="text-2xl font-black text-slate-800 tracking-tight mb-3 text-center">
        {title}
      </h3>
      
      <p className="text-slate-500 text-sm max-w-md text-center leading-relaxed">
        {message}
      </p>
      
      <div className="mt-8 px-6 py-2 bg-slate-50 border border-slate-100 rounded-full flex items-center gap-2 shadow-sm">
     
      </div>
    </div>
  );
}
